import EmptyPlaceholder from '@/components/EmptyPlaceholder'
import { css } from '@emotion/react'
import { Link } from '@tanstack/react-router'
import { motion } from 'motion/react'
import Button from './Button'

export default function NotFoundPage() {
	const location = window.location

	return (
		<motion.div
			key={location.pathname}
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
			css={css`
				padding: calc(var(--navbar-height) + 12px) 15px
					calc(env(safe-area-inset-bottom, 20px) + 15px);
				overflow: hidden;
				overflow-y: auto;
				height: 100vh;
				background-color: var(--bg-body-base-1);
			`}
		>
			<EmptyPlaceholder
				title="什么也找不到"
				css={css`
					height: 100%;
				`}
			>
				<Link to="/">
					<Button appearance="ghost" size="sm">
						返回首页
					</Button>
				</Link>
			</EmptyPlaceholder>
		</motion.div>
	)
}
